/* eslint-disable max-len */

// Public
export const SR_API_ACTION_LOGIN = 'SR_API_ACTION_LOGIN';
export const SR_API_ACTION_LOGOUT = 'SR_API_ACTION_LOGOUT';
export const SR_API_ACTION_LOGONAS = 'SR_API_ACTION_LOGONAS';
export const SR_API_ACTION_CHECK_LOGIN_EXIST = 'SR_API_ACTION_CHECK_LOGIN_EXIST';
export const SR_API_ACTION_RESET_PASSWORD = 'SR_API_ACTION_RESET_PASSWORD';
export const SR_API_ACTION_GENERATE_RESET_PASSWORD_TOKEN =
  'SR_API_ACTION_GENERATE_RESET_PASSWORD_TOKEN';
export const SR_API_ACTION_VERIFY_PHONE_SMS_CODE_REQUESTED =
  'SR_API_ACTION_VERIFY_PHONE_SMS_CODE_REQUESTED';
export const SR_API_ACTION_VERIFY_PHONE_SMS_CODE_SUBMIT =
  'SR_API_ACTION_VERIFY_PHONE_SMS_CODE_SUBMIT';
export const SR_API_ACTION_VERIFY_ACCOUNT_EXIST = 'SR_API_ACTION_VERIFY_ACCOUNT_EXIST';
export const SR_API_ACTION_SIGNUP = 'SR_API_ACTION_SIGNUP';
export const SR_API_ACTION_PARTNER_SIGNUP = 'SR_API_ACTION_PARTNER_SIGNUP';
export const SR_API_ACTION_BUYER_SIDE_AGENT_SIGNUP = 'SR_API_ACTION_BUYER_SIDE_AGENT_SIGNUP';
export const SR_API_ACTION_BUYER_SIDE_AGENT_UPDATE = 'SR_API_ACTION_BUYER_SIDE_AGENT_UPDATE';
export const SR_API_ACTION_LANDLORD_SIGNUP = 'SR_API_ACTION_LANDLORD_SIGNUP';
export const SR_API_ACTION_ROOMMATE_SIGNUP = 'SR_API_ACTION_ROOMMATE_SIGNUP';
export const SR_API_ACTION_ROOMMATE_INVITES = 'SR_API_ACTION_ROOMMATE_INVITES';
export const SR_API_ACTION_GUARANTOR_SIGNUP = 'SR_API_ACTION_GUARANTOR_SIGNUP';
export const SR_API_ACTION_GUARANTOR_INVITE = 'SR_API_ACTION_GUARANTOR_INVITE';
export const SR_API_ACTION_HOUSEHOLD_ADD_GUARANTOR = 'SR_API_ACTION_HOUSEHOLD_ADD_GUARANTOR';
export const SR_API_ACTION_SEND_APPLICATION_EMAIL = 'SR_API_ACTION_SEND_APPLICATION_EMAIL';
export const SR_API_ACTION_GET_LISTING_BY_ID = 'SR_API_ACTION_GET_LISTING_BY_ID';
export const SR_API_ACTION_GET_TOUR_HEALTH = 'SR_API_ACTION_GET_TOUR_HEALTH';
export const SR_API_ACTION_GET_SUNLOCK_HEALTH = 'SR_API_ACTION_GET_SUNLOCK_HEALTH';
export const SR_API_ACTION_GET_LISTING_BY_ADDRESS_FIELDS =
  'SR_API_ACTION_GET_LISTING_BY_ADDRESS_FIELDS';
export const SR_API_ACTION_GET_LISTING_BY_MLS_NUMBER = 'SR_API_ACTION_GET_LISTING_BY_MLS_NUMBER';
export const SR_API_ACTION_GET_LISTING_BY_FUZZY_ADDRESS_SEARCH =
  'SR_API_ACTION_GET_LISTING_BY_FUZZY_ADDRESS_SEARCH';
export const SR_API_ACTION_GET_APARTMENT_BUILDINGS_BY_FUZZY_ADDRESS_SEARCH =
  'SR_API_ACTION_GET_APARTMENT_BUILDINGS_BY_FUZZY_ADDRESS_SEARCH';
export const SR_API_ACTION_GET_LISTING_BY_APARTMENT_UNIT_SEARCH =
  'SR_API_ACTION_GET_LISTING_BY_APARTMENT_UNIT_SEARCH';
export const SR_API_ACTION_FUZZY_SEARCH_ADDRESS_STREET_SUFFIX =
  'SR_API_ACTION_FUZZY_SEARCH_ADDRESS_STREET_SUFFIX';
export const SR_API_ACTION_FUZZY_SEARCH = 'SR_API_ACTION_FUZZY_SEARCH';
export const SR_API_ACTION_GET_LISTING_LIST = 'SR_API_ACTION_GET_LISTING_LIST';
export const SR_API_ACTION_GET_LISTING_LINKS = 'SR_API_ACTION_GET_LISTING_LINKS';
export const SR_API_ACTION_GET_APARTMENT_LINKS = 'SR_API_ACTION_GET_APARTMENT_LINKS';
export const SR_API_ACTION_GET_APARTMENTS_LIST = 'SR_API_ACTION_GET_APARTMENTS_LIST';
export const SR_API_ACTION_GET_PARTNER_APARTMENTS_LIST =
  'SR_API_ACTION_GET_PARTNER_APARTMENTS_LIST';
export const SR_API_ACTION_GET_USER_BY_PHONE = 'SR_API_ACTION_GET_USER_BY_PHONE';
export const SR_API_ACTION_GET_USER_BY_ID = 'SR_API_ACTION_GET_USER_BY_ID';
export const SR_API_ACTION_GET_USER_BY_PHONE_HOUSEHOLD_ID =
  'SR_API_ACTION_GET_USER_BY_PHONE_HOUSEHOLD_ID';
export const SR_API_ACTION_GET_USER_BOOKMARKS = 'SR_API_ACTION_GET_USER_BOOKMARKS';
export const SR_API_ACTION_ADD_USER_BOOKMARK = 'SR_API_ACTION_ADD_USER_BOOKMARK';
export const SR_API_ACTION_GET_USER_ASSIGNED_CUSTOMER_SUPPORT_PHONE_NUMBER =
  'SR_API_ACTION_GET_USER_ASSIGNED_CUSTOMER_SUPPORT_PHONE_NUMBER';
export const SR_API_ACTION_GET_USER_SEARCH_QUERIES = 'SR_API_ACTION_GET_USER_SEARCH_QUERIES';
export const SR_API_ACTION_GET_USER_SUGGESTED_SEARCH_FILTERS =
  'SR_API_ACTION_GET_USER_SUGGESTED_SEARCH_FILTERS';
export const SR_API_ACTION_LISTING_WANTS_TO_APPLY = 'SR_API_ACTION_LISTING_WANTS_TO_APPLY';
export const SR_API_ACTION_REMOVE_USER_BOOKMARK = 'SR_API_ACTION_REMOVE_USER_BOOKMARK';
export const SR_API_ACTION_GET_TOUR_LIST = 'SR_API_ACTION_GET_TOUR_LIST';
export const SR_API_ACTION_REQUEST_TOUR_SHOWING = 'SR_API_ACTION_REQUEST_TOUR_SHOWING';
export const SR_API_ACTION_SEND_TOUR_REQUEST_EMAIL = 'SR_API_ACTION_SEND_TOUR_REQUEST_EMAIL';
export const SR_API_ACTION_RESCHEDULE_TOUR = 'SR_API_ACTION_RESCHEDULE_TOUR';
export const SR_API_ACTION_CANCEL_TOUR = 'SR_API_ACTION_CANCEL_TOUR';
export const SR_API_ACTION_UPDATE_USER = 'SR_API_ACTION_UPDATE_USER';
export const SR_API_ACTION_UPDATE_USER_SETTINGS = 'SR_API_ACTION_UPDATE_USER_SETTINGS';
export const SR_API_ACTION_RUN_CRON_TASK = 'SR_API_ACTION_RUN_CRON_TASK';
export const SR_API_ACTION_GET_STATS = 'SR_API_ACTION_GET_STATS';
export const SR_API_ACTION_SANITIZE_USER_DATA = 'SR_API_ACTION_SANITIZE_USER_DATA';
export const SR_API_ACTION_APPLY_TOUR_STATE_CHANGE = 'SR_API_ACTION_APPLY_TOUR_STATE_CHANGE';
export const SR_API_ACTION_APPLY_APPLICATION_STATE_CHANGE =
  'SR_API_ACTION_APPLY_APPLICATION_STATE_CHANGE';
export const SR_API_ACTION_GET_DATA_TABLE_ITEMS = 'SR_API_ACTION_GET_DATA_TABLE_ITEMS';
export const SR_API_ACTION_CONFIRM_PHONE = 'SR_API_ACTION_CONFIRM_PHONE';
export const SR_API_ACTION_CONFIRM_MOVE_IN = 'SR_API_ACTION_CONFIRM_MOVE_IN';
export const SR_API_ACTION_UPDATE_MOVE_IN_DATE = 'SR_API_ACTION_UPDATE_MOVE_IN_DATE';
export const SR_API_ACTION_CHECK_IF_SHOULD_REQUEST_MOVE_IN_DATE_CHANGE =
  'SR_API_ACTION_CHECK_IF_SHOULD_REQUEST_MOVE_IN_DATE_CHANGE';
export const SR_API_ACTION_ADMIN_UPDATE_LISTING_PHOTOS =
  'SR_API_ACTION_ADMIN_UPDATE_LISTING_PHOTOS';
export const SR_API_ACTION_ROOMMATE_APPLICATION = 'SR_API_ACTION_ROOMMATE_APPLICATION';
export const SR_API_ACTION_DELETE_SHOWING = 'SR_API_ACTION_DELETE_SHOWING';
export const SR_API_ACTION_SET_EXPERIMENT_ACTIVE_VARIANTS =
  'SR_API_ACTION_SET_EXPERIMENT_ACTIVE_VARIANTS';
export const SR_API_ACTION_LISTING_ASK_A_QUESTION_BUTTON_CLICK =
  'SR_API_ACTION_LISTING_ASK_A_QUESTION_BUTTON_CLICK';
export const SR_API_ACTION_LISTING_CALL_BUTTON_CLICK = 'SR_API_ACTION_LISTING_CALL_BUTTON_CLICK';
export const SR_API_ACTION_LISTING_SEND_QUESTION_EMAIL =
  'SR_API_ACTION_LISTING_SEND_QUESTION_EMAIL';
export const SR_API_ACTION_LISTING_CONTACT_APARTMENT_LOCATOR_BUTTON_CLICK =
  'SR_API_ACTION_LISTING_CONTACT_APARTMENT_LOCATOR_BUTTON_CLICK';
export const SR_API_ACTION_LISTING_CHECK_AVAILABILITY_BUTTON_CLICK =
  'SR_API_ACTION_LISTING_CHECK_AVAILABILITY_BUTTON_CLICK';
export const SR_API_ACTION_LISTING_UPDATE_RENEWAL_SEGMENT_EVENT =
  'SR_API_ACTION_LISTING_UPDATE_RENEWAL_SEGMENT_EVENT';
export const SR_API_ACTION_LISTING_UPDATE_PROPERTY_CONDITION_REPORT =
  'SR_API_ACTION_LISTING_UPDATE_PROPERTY_CONDITION_REPORT';
export const SR_API_ACTION_MARK_INSTALLATION_AS_COMPLETED =
  'SR_API_ACTION_MARK_INSTALLATION_AS_COMPLETED';
export const SR_API_ACTION_LISTING_UPDATE_GTM_EMAIL_SENT_TO_PARTNER =
  'SR_API_ACTION_LISTING_UPDATE_GTM_EMAIL_SENT_TO_PARTNER';
export const SR_API_ACTION_GET_LISTINGS_ELIGIBLE_FOR_DISCOUNTS =
  'SR_API_ACTION_GET_LISTINGS_ELIGIBLE_FOR_DISCOUNTS';
export const SR_API_ACTION_GET_USER_CHECK_AVAILABILITY_LISTINGS =
  'SR_API_ACTION_GET_USER_CHECK_AVAILABILITY_LISTINGS';
export const SR_API_ACTION_GET_APP_COMMIT_HASH = 'SR_API_ACTION_GET_APP_COMMIT_HASH';
export const SR_API_ACTION_UPDATE_TOUR_SHOWING_STATUS = 'SR_API_ACTION_UPDATE_TOUR_SHOWING_STATUS';
export const SR_API_ACTION_RENTER_GET_VIEWED_LISTINGS = 'SR_API_ACTION_RENTER_GET_VIEWED_LISTINGS';
export const SR_API_ACTION_RENTER_UPDATE_VIEWED_LISTINGS =
  'SR_API_ACTION_RENTER_UPDATE_VIEWED_LISTINGS';
export const SR_API_ACTION_UPDATE_RENTER_FRONT_TAGS = 'SR_API_ACTION_UPDATE_RENTER_FRONT_TAGS';
export const SR_API_ACTION_JOIN_SUNROOM_CLUB = 'SR_API_ACTION_JOIN_SUNROOM_CLUB';
export const SR_API_ACTION_SUBMIT_SUNROOM_CLUB_QUESTIONNAIRE =
  'SR_API_ACTION_SUBMIT_SUNROOM_CLUB_QUESTIONNAIRE';
export const SR_API_ACTION_UPDATE_USER_DEVICE_REGISTRATION_IDS =
  'SR_API_ACTION_UPDATE_USER_DEVICE_REGISTRATION_IDS';
export const SR_API_ACTION_CALCULATE_TOUR_ROUTE = 'SR_API_ACTION_CALCULATE_TOUR_ROUTE';
export const SR_API_ACTION_USER_ADD_SEARCH_FILTER_HISTORY =
  'SR_API_ACTION_USER_ADD_SEARCH_FILTER_HISTORY';
export const SR_API_ACTION_GET_LISTINGS_QUALIFIED_TO_RENT =
  'SR_API_ACTION_GET_LISTINGS_QUALIFIED_TO_RENT';
export const SR_API_ACTION_LISTING_GET_PROPERTY_FEATURES =
  'SR_API_ACTION_LISTING_GET_PROPERTY_FEATURES';
export const SR_API_ACTION_GET_MOST_POPULAR_LISTINGS = 'SR_API_ACTION_GET_MOST_POPULAR_LISTINGS';
export const SR_API_ACTION_GET_FURTHER_COMMUTE_LISTINGS =
  'SR_API_ACTION_GET_FURTHER_COMMUTE_LISTINGS';
export const SR_API_ACTION_GET_SPECIFIC_APARTMENTS_LISTINGS =
  'SR_API_ACTION_GET_SPECIFIC_APARTMENTS_LISTINGS';
export const SR_API_ACTION_GET_LAST_VISITED_LISTINGS = 'SR_API_ACTION_GET_LAST_VISITED_LISTINGS';
export const SR_API_ACTION_GET_LISTING_SUNLOCK_CODE = 'SR_API_ACTION_GET_LISTING_SUNLOCK_CODE';
export const SR_API_ACTION_GET_REDIRECTION = 'SR_API_ACTION_GET_REDIRECTION';
export const SR_API_ACTION_GET_REDIRECTION_BY_LISTING_ID =
  'SR_API_ACTION_GET_REDIRECTION_BY_LISTING_ID';
export const SR_API_ACTION_SET_REDIRECTION = 'SR_API_ACTION_SET_REDIRECTION';
export const SR_API_ACTION_MAKE_REDIRECTION_CODE = 'SR_API_ACTION_MAKE_REDIRECTION_CODE';
export const SR_API_ACTION_DELETE_REDIRECTION = 'SR_API_ACTION_DELETE_REDIRECTION';
export const SR_API_ACTION_GET_LISTING_UNITS = 'SR_API_ACTION_GET_LISTING_UNITS';
export const SR_API_ACTION_GET_APARTMENT_COMPLEX_UNIT_GROUP_LIST =
  'SR_API_ACTION_GET_APARTMENT_COMPLEX_UNIT_GROUP_LIST';
export const SR_API_ACTION_CREATE_OR_EDIT_APARTMENT_COMPLEX_UNIT_GROUP =
  'SR_API_ACTION_CREATE_OR_EDIT_APARTMENT_COMPLEX_UNIT_GROUP';
export const SR_API_ACTION_DELETE_APARTMENT_COMPLEX_UNIT_GROUP =
  'SR_API_ACTION_DELETE_APARTMENT_COMPLEX_UNIT_GROUP';
export const SR_API_ACTION_GET_MARKET_BY_ID = 'SR_API_ACTION_GET_MARKET_BY_ID';
export const SR_API_ACTION_GET_MARKET_LIST = 'SR_API_ACTION_GET_MARKET_LIST';
export const SR_API_ACTION_GET_NEIGHBORHOOD_LIST = 'SR_API_ACTION_GET_NEIGHBORHOOD_LIST';
export const SR_API_ACTION_UPSERT_LISTING = 'SR_API_ACTION_UPSERT_LISTING';
export const SR_API_ACTION_UPSERT_LISTING_LINKS = 'SR_API_ACTION_UPSERT_LISTING_LINKS';
export const SR_API_ACTION_RATE_TOUR = 'SR_API_ACTION_RATE_TOUR';
export const SR_API_ACTION_GET_AVAILABLE_TOUR_DATES = 'SR_API_ACTION_GET_AVAILABLE_TOUR_DATES';
export const SR_API_ACTION_GET_UNAVAILABLE_TOUR_DATES = 'SR_API_ACTION_GET_UNAVAILABLE_TOUR_DATES';
export const SR_API_ACTION_GET_APARTMENT_BY_ID = 'SR_API_ACTION_GET_APARTMENT_BY_ID';
export const SR_API_ACTION_GET_APARTMENT_BITLY_LINK = 'SR_API_ACTION_GET_APARTMENT_BITLY_LINK';
export const SR_API_ACTION_GET_LISTING_GATE_CODE = 'SR_API_ACTION_GET_LISTING_GATE_CODE';
export const SR_API_ACTION_RUN_CREDIT_AND_BACKGROUND_REPORT =
  'SR_API_ACTION_RUN_CREDIT_AND_BACKGROUND_REPORT';
export const SR_API_ACTION_GET_TENANT_ALERT_REPORT = 'SR_API_ACTION_GET_TENANT_ALERT_REPORT';
export const SR_API_ACTION_GET_TENANT_ALERT_APPLICATION =
  'SR_API_ACTION_GET_TENANT_ALERT_APPLICATION';
export const SR_API_ACTION_NEW_TENANT_ALERT_APPLICATION =
  'SR_API_ACTION_NEW_TENANT_ALERT_APPLICATION';
export const SR_API_ACTION_GET_TENANT_SCREENING_CRITERIA =
  'SR_API_ACTION_GET_TENANT_SCREENING_CRITERIA';
export const SR_API_ACTION_UPDATE_BREED_RESTRICTIONS = 'SR_API_ACTION_UPDATE_BREED_RESTRICTIONS';
export const SR_API_ACTION_CLONE_BREED_RESTRICTIONS = 'SR_API_ACTION_CLONE_BREED_RESTRICTIONS';
export const SR_API_ACTION_UPSERT_COMPARATIVE_MARKET_ANALYSIS =
  'SR_API_ACTION_UPSERT_COMPARATIVE_MARKET_ANALYSIS';
export const SR_API_ACTION_LISTING_SUNLOCK_GEOLOCATION_ERROR =
  'SR_API_ACTION_LISTING_SUNLOCK_GEOLOCATION_ERROR';
export const SR_API_ACTION_GET_HOUSEHOLDS_APPLYING_TO_LISTING =
  'SR_API_ACTION_GET_HOUSEHOLDS_APPLYING_TO_LISTING';
export const SR_API_ACTION_LISTING_REQUEST_ONLINE_APP = 'SR_API_ACTION_LISTING_REQUEST_ONLINE_APP';
export const SR_API_ACTION_LOAD_FUZZY_SEARCH_LISTINGS = 'SR_API_ACTION_LOAD_FUZZY_SEARCH_LISTINGS';
export const SR_API_ACTION_LISTING_GET = 'SR_API_ACTION_LISTING_GET';
export const SR_API_ACTION_TOUR_CREATE_SELF_SHOWING = 'SR_API_ACTION_TOUR_CREATE_SELF_SHOWING';
export const SR_API_ACTION_TOUR_GET_BY_ID = 'SR_API_ACTION_TOUR_GET_BY_ID';
export const SR_API_ACTION_GET_HIERARCHICAL_MEDIA = 'SR_API_ACTION_GET_HIERARCHICAL_MEDIA';
export const SR_API_ACTION_MEDIA_UPSERT = 'SR_API_ACTION_MEDIA_UPSERT';
export const SR_API_ACTION_MEDIA_DELETE = 'SR_API_ACTION_MEDIA_DELETE';
export const SR_API_ACTION_REQUEST_BUYERS_SIDE_APPLICATION =
  'SR_API_ACTION_REQUEST_BUYERS_SIDE_APPLICATION';
export const SR_API_ACTION_ADMIN_REFRESH_CUSTOMER_IO_COLLECTION =
  'SR_API_ACTION_ADMIN_REFRESH_CUSTOMER_IO_COLLECTION';
export const SR_API_ACTION_CONNECT_BANK_ACCOUNT = 'SR_API_ACTION_CONNECT_BANK_ACCOUNT';
export const SR_API_ACTION_CANCEL_APPLICATION_WTA_FOLLOW_UPS =
  'SR_API_ACTION_CANCEL_APPLICATION_WTA_FOLLOW_UPS';
export const SR_API_ACTION_TOUR_FAILED_FEEDBACK = 'SR_API_ACTION_TOUR_FAILED_FEEDBACK';
export const SR_API_ACTION_TOUR_JOIN_WAITLIST = 'SR_API_ACTION_TOUR_JOIN_WAITLIST';

export const SR_API_ACTION_USER_CREATE_STRIPE_CUSTOMER =
  'SR_API_ACTION_USER_CREATE_STRIPE_CUSTOMER';
export const SR_API_ACTION_USER_PARTNER_APP_INSTALLED = 'SR_API_ACTION_USER_PARTNER_APP_INSTALLED';
export const SR_API_ACTION_USER_GENERATE_AUTO_LOGIN_URL =
  'SR_API_ACTION_USER_GENERATE_AUTO_LOGIN_URL';
export const SR_API_ACTION_USER_CREATE_PAYMENT_ACCOUNT =
  'SR_API_ACTION_USER_CREATE_PAYMENT_ACCOUNT';
export const SR_API_ACTION_USER_GET_PAYMENT_ACCOUNTS = 'SR_API_ACTION_USER_GET_PAYMENT_ACCOUNTS';
export const SR_API_ACTION_USER_GET_PAYMENT_ACCOUNT = 'SR_API_ACTION_USER_GET_PAYMENT_ACCOUNT';
export const SR_API_ACTION_USER_DELETE_PAYMENT_ACCOUNT =
  'SR_API_ACTION_USER_DELETE_PAYMENT_ACCOUNT';

export const SR_API_ACTION_TENANT_SCREENING_CRITERIA_UPSERT =
  'SR_API_ACTION_TENANT_SCREENING_CRITERIA_UPSERT';

export const SR_API_ACTION_LISTING_GET_SETUP_CODES = 'SR_API_ACTION_LISTING_GET_SETUP_CODES';
export const SR_API_ACTION_CHECK_SELF_TOUR_REQUEST = 'SR_API_ACTION_CHECK_SELF_TOUR_REQUEST';
export const SR_API_ACTION_LISTING_IS_ADDRESS_UNIQUE = 'SR_API_ACTION_LISTING_IS_ADDRESS_UNIQUE';
export const SR_API_ACTION_LISTING_JOB_ITEMS_INSTALLED =
  'SR_API_ACTION_LISTING_JOB_ITEMS_INSTALLED';
export const SR_API_ACTION_LISTING_ARCHIVE = 'SR_API_ACTION_LISTING_ARCHIVE';
export const SR_API_ACTION_LISTING_GET_LEAD_HEALTH = 'SR_API_ACTION_LISTING_GET_LEAD_HEALTH';
export const SR_API_ACTION_LISTING_NOTE_GET_LIST = 'SR_API_ACTION_LISTING_NOTE_GET_LIST';
export const SR_API_ACTION_LISTING_NOTE_CREATE = 'SR_API_ACTION_LISTING_NOTE_CREATE';
export const SR_API_ACTION_LISTING_SUNSETUP_WITHDRAW = 'SR_API_ACTION_LISTING_SUNSETUP_WITHDRAW';
export const SR_API_ACTION_LISTING_SHOULD_CHARGE_WITHDRAW_FEE =
  'SR_API_ACTION_LISTING_SHOULD_CHARGE_WITHDRAW_FEE';
export const SR_API_ACTION_LISTING_GET_WEEKLY_LEADS = 'SR_API_ACTION_LISTING_GET_WEEKLY_LEADS';
export const SR_API_ACTION_LISTING_GET_DAILY_PAST_SEVEN_DAYS_LEADS =
  'SR_API_ACTION_LISTING_GET_DAILY_PAST_SEVEN_DAYS_LEADS';
export const SR_API_ACTION_LISTING_GET_PRICE_CHANGES = 'SR_API_ACTION_LISTING_GET_PRICE_CHANGES';
export const SR_API_ACTION_LISTING_ALARM_TURN_OFF_FAILED =
  'SR_API_ACTION_LISTING_ALARM_TURN_OFF_FAILED';
export const SR_API_ACTION_LISTING_GET_SCHEDULED_LEAD_TOURS_COUNT =
  'SR_API_ACTION_LISTING_GET_SCHEDULED_LEAD_TOURS_COUNT';

export const SR_API_ACTION_PRE_LEASE_GET_BY_LISTING_ID =
  'SR_API_ACTION_PRE_LEASE_GET_BY_LISTING_ID';

export const SR_API_ACTION_FRONT_GET_CONVERSATION_MESSAGES =
  'SR_API_ACTION_FRONT_GET_CONVERSATION_MESSAGES';
export const SR_API_ACTION_FRONT_GET_CONVERSATION_COMMENTS =
  'SR_API_ACTION_FRONT_GET_CONVERSATION_COMMENTS';
export const SR_API_ACTION_FRONT_CREATE_MESSAGE = 'SR_API_ACTION_FRONT_CREATE_MESSAGE';

// Admin
export const SR_API_ACTION_ADMIN_UPDATE_ITEM = 'SR_API_ACTION_ADMIN_UPDATE_ITEM';
export const SR_API_ACTION_ADMIN_DELETE_SHOWING = 'SR_API_ACTION_ADMIN_DELETE_SHOWING';
export const SR_API_ACTION_ADMIN_UNSCHEDULE_SHOWING = 'SR_API_ACTION_ADMIN_UNSCHEDULE_SHOWING';
export const SR_API_ACTION_ADMIN_ADD_SHOWING_TO_TOUR = 'SR_API_ACTION_ADMIN_ADD_SHOWING_TO_TOUR';
export const SR_API_ACTION_ADMIN_MARK_SHOWING_AVAILABLE =
  'SR_API_ACTION_ADMIN_MARK_SHOWING_AVAILABLE';
export const SR_API_ACTION_ADMIN_MARK_SHOWING_NOT_AVAILABLE =
  'SR_API_ACTION_ADMIN_MARK_SHOWING_NOT_AVAILABLE';
export const SR_API_ACTION_ADMIN_MARK_TOUR_NO_SHOW = 'SR_API_ACTION_ADMIN_MARK_TOUR_NO_SHOW';
export const SR_API_ACTION_ADMIN_MARK_TOUR_NEEDS_RESCHEDULING =
  'SR_API_ACTION_ADMIN_MARK_TOUR_NEEDS_RESCHEDULING';
export const SR_API_ACTION_ADMIN_UPDATE_ALL_LISTINGS = 'SR_API_ACTION_ADMIN_UPDATE_ALL_LISTINGS';
export const SR_API_ACTION_ADMIN_UPDATE_SMART_APARTMENT_LISTINGS =
  'SR_API_ACTION_ADMIN_UPDATE_SMART_APARTMENT_LISTINGS';
export const SR_API_ACTION_ADMIN_UPDATE_SHOWING_POSITIONS =
  'SR_API_ACTION_ADMIN_UPDATE_SHOWING_POSITIONS';
export const SR_API_ACTION_ADMIN_REQUEST_TOUR_SHOWING = 'SR_API_ACTION_ADMIN_REQUEST_TOUR_SHOWING';
export const SR_API_ACTION_ADMIN_SMS_BLASTER = 'SR_API_ACTION_ADMIN_SMS_BLASTER';
export const SR_API_ACTION_ADMIN_GENERATE_AUTO_LOGIN_SHORT_URLS =
  'SR_API_ACTION_ADMIN_GENERATE_AUTO_LOGIN_SHORT_URLS';
export const SR_API_ACTION_ADMIN_GET_PINNED_LISTINGS = 'SR_API_ACTION_ADMIN_GET_PINNED_LISTINGS';
export const SR_API_ACTION_ADMIN_GET_TOURS_BY_USER_ID = 'SR_API_ACTION_ADMIN_GET_TOURS_BY_USER_ID';
export const SR_API_ACTION_ADMIN_OVERRIDE_LISTING_DATA =
  'SR_API_ACTION_ADMIN_OVERRIDE_LISTING_DATA';
export const SR_API_ACTION_ADMIN_ADD_TOUR_DATES_UNAVAILABLE =
  'SR_API_ACTION_ADMIN_ADD_TOUR_DATES_UNAVAILABLE';
export const SR_API_ACTION_ADMIN_GET_ALL_TOUR_DATES_UNAVAILABLE =
  'SR_API_ACTION_ADMIN_GET_ALL_TOUR_DATES_UNAVAILABLE';
export const SR_API_ACTION_ADMIN_REMOVE_TOUR_DATE_UNAVAILABLE =
  'SR_API_ACTION_ADMIN_REMOVE_TOUR_DATE_UNAVAILABLE';
export const SR_API_ACTION_ADMIN_ASSIGN_AGENT_TO_TOUR = 'SR_API_ACTION_ADMIN_ASSIGN_AGENT_TO_TOUR';
export const SR_API_ACTION_ADMIN_UPDATE_FRONT_TAGS = 'SR_API_ACTION_ADMIN_UPDATE_FRONT_TAGS';
export const SR_API_ACTION_ADMIN_UPDATE_TOUR_START_DATE =
  'SR_API_ACTION_ADMIN_UPDATE_TOUR_START_DATE';
export const SR_API_ACTION_ADMIN_GET_USERS_WITH_ROLE = 'SR_API_ACTION_ADMIN_GET_USERS_WITH_ROLE';
export const SR_API_ACTION_ADMIN_UPDATE_LOW_BUDGET_PROPERTY_TYPES =
  'SR_API_ACTION_ADMIN_UPDATE_LOW_BUDGET_PROPERTY_TYPES';
export const SR_API_ACTION_ADMIN_SEND_PUSH_NOTIFICATION =
  'SR_API_ACTION_ADMIN_SEND_PUSH_NOTIFICATION';
export const SR_API_ACTION_ADMIN_UPDATE_TWILIO_PHONE_NUMBER =
  'SR_API_ACTION_ADMIN_UPDATE_TWILIO_PHONE_NUMBER';
export const SR_API_ACTION_ADMIN_GET_TWILIO_PHONE_NUMBER =
  'SR_API_ACTION_ADMIN_GET_TWILIO_PHONE_NUMBER';
export const SR_API_ACTION_ADMIN_GET_FRONT_CHANNELS = 'SR_API_ACTION_ADMIN_GET_FRONT_CHANNELS';
export const SR_API_ACTION_ADMIN_ADD_FRONT_CHANNEL = 'SR_API_ACTION_ADMIN_ADD_FRONT_CHANNEL';
export const SR_API_ACTION_ADMIN_REMOVE_FRONT_CHANNEL = 'SR_API_ACTION_ADMIN_REMOVE_FRONT_CHANNEL';
export const SR_API_ACTION_ADMIN_REGENERATE_SUNROOM_PHOTOS =
  'SR_API_ACTION_ADMIN_REGENERATE_SUNROOM_PHOTOS';
export const SR_API_ACTION_ADMIN_REGENERATE_SUNROOM_PHOTOS_BY_LISTING_ID =
  'SR_API_ACTION_ADMIN_REGENERATE_SUNROOM_PHOTOS_BY_LISTING_ID';
export const SR_API_ACTION_ADMIN_REGENERATE_PARTNER_LISTING_PHOTOS =
  'SR_API_ACTION_ADMIN_REGENERATE_PARTNER_LISTING_PHOTOS';
export const SR_API_ACTION_ADMIN_REGENERATE_PARTNER_WATERMARKS =
  'SR_API_ACTION_ADMIN_REGENERATE_PARTNER_WATERMARKS';
export const SR_API_ACTION_ADMIN_REGENERATE_LISTING_WATERMARKS =
  'SR_API_ACTION_ADMIN_REGENERATE_LISTING_WATERMARKS';
export const SR_API_ACTION_ADMIN_REGENERATE_LISTING_CONCESSION_WATERMARKS =
  'SR_API_ACTION_ADMIN_REGENERATE_LISTING_CONCESSION_WATERMARKS';
export const SR_API_ACTION_ADMIN_MESSAGE_TENANT = 'SR_API_ACTION_ADMIN_MESSAGE_TENANT';
export const SR_API_ACTION_PARTNER_SEND_MOBILE_APP_DOWNLOAD_LINK =
  'SR_API_ACTION_PARTNER_SEND_MOBILE_APP_DOWNLOAD_LINK';
export const SR_API_ACTION_ADMIN_DEPLOY = 'SR_API_ACTION_ADMIN_DEPLOY';
export const SR_API_ACTION_ADD_LISTING_TO_TOUR = 'SR_API_ACTION_ADD_LISTING_TO_TOUR';
export const SR_API_ACTION_ADMIN_GET_HOMEBASE_EMPLOYEES =
  'SR_API_ACTION_ADMIN_GET_HOMEBASE_EMPLOYEES';
export const SR_API_ACTION_ADD_MOBILE_APP_USER_COMMENT =
  'SR_API_ACTION_ADD_MOBILE_APP_USER_COMMENT';
export const SR_API_ACTION_ADMIN_ENSURE_RENTER_HOUSEHOLDS_SCRIPT =
  'SR_API_ACTION_ADMIN_ENSURE_RENTER_HOUSEHOLDS_SCRIPT';
export const SR_API_ACTION_ADMIN_ASSIGN_OUT_OF_RANGE_APARTMENT_LOCATOR_LEADS_SCRIPT =
  'SR_API_ACTION_ADMIN_ASSIGN_OUT_OF_RANGE_APARTMENT_LOCATOR_LEADS_SCRIPT';
export const SR_API_ACTION_ADMIN_AUTO_ASSIGN_HOUSEHOLDS_TO_CANCELLED_TOURS_SCRIPT =
  'SR_API_ACTION_ADMIN_AUTO_ASSIGN_HOUSEHOLDS_TO_CANCELLED_TOURS_SCRIPT';
export const SR_API_ACTION_ADMIN_CREATE_USER_REQUEST_TOUR =
  'SR_API_ACTION_ADMIN_CREATE_USER_REQUEST_TOUR';
export const SR_API_ACTION_ADMIN_CREATE_JWT_TOKEN = 'SR_API_ACTION_ADMIN_CREATE_JWT_TOKEN';
export const SR_API_ACTION_ADMIN_GET_TOUR_GUIDE_SCHEDULES =
  'SR_API_ACTION_ADMIN_GET_TOUR_GUIDE_SCHEDULES';
export const SR_API_ACTION_ADMIN_MIGRATE_LEASE_DRAFTS = 'SR_API_ACTION_ADMIN_MIGRATE_LEASE_DRAFTS';
export const SR_API_ACTION_ADMIN_SCRAPE_PARTNER_LISTINGS =
  'SR_API_ACTION_ADMIN_SCRAPE_PARTNER_LISTINGS';
export const SR_API_ACTION_ADMIN_GENERATE_APARTMENTS_BY_PARTNER =
  'SR_API_ACTION_ADMIN_GENERATE_APARTMENTS_BY_PARTNER';
export const SR_API_ACTION_SANITIZE_PET_DATA = 'SR_API_ACTION_SANITIZE_PET_DATA';
export const SR_API_ACTION_ADMIN_PIN_SUNROOM_LISTINGS = 'SR_API_ACTION_ADMIN_PIN_SUNROOM_LISTINGS';
export const SR_API_ACTION_ADMIN_ADD_LOCATION_POINT_TO_LISTINGS =
  'SR_API_ACTION_ADMIN_ADD_LOCATION_POINT_TO_LISTINGS';
export const SR_API_ACTION_RENTLINX_SET_VERIFICATION_COOKIE =
  'SR_API_ACTION_RENTLINX_SET_VERIFICATION_COOKIE';
export const SR_API_ACTION_ADMIN_SCRAPE_RENTLINX_LEADS =
  'SR_API_ACTION_ADMIN_SCRAPE_RENTLINX_LEADS';
export const SR_API_ACTION_PROCESS_LEAD = 'SR_API_ACTION_PROCESS_LEAD';
export const SR_API_ACTION_ARCHIVE_RENTLINX_LISTING_LEAD =
  'SR_API_ACTION_ARCHIVE_RENTLINX_LISTING_LEAD';
export const SR_API_ACTION_UNARCHIVE_RENTLINX_LISTING_LEAD =
  'SR_API_ACTION_UNARCHIVE_RENTLINX_LISTING_LEAD';
export const SR_API_ACTION_ADMIN_RESET_SR_PHOTOS = 'SR_API_ACTION_ADMIN_RESET_SR_PHOTOS';
export const SR_API_ACTION_ADMIN_CREATE_QUEUE_JOB = 'SR_API_ACTION_ADMIN_CREATE_QUEUE_JOB';
export const SR_API_ACTION_ADMIN_ENCRYPT_SSNS = 'SR_API_ACTION_ADMIN_ENCRYPT_SSNS';
export const SR_API_ACTION_ADMIN_RESET_HOUSEHOLD_OVERVIEW_SETTINGS =
  'SR_API_ACTION_ADMIN_RESET_HOUSEHOLD_OVERVIEW_SETTINGS';
export const SR_API_ACTION_ADMIN_CREATE_PARTNER_SALE = 'SR_API_ACTION_ADMIN_CREATE_PARTNER_SALE';
export const SR_API_ACTION_ADMIN_GET_LISTING_TOUR_HEALTH_LIST =
  'SR_API_ACTION_ADMIN_GET_LISTING_TOUR_HEALTH_LIST';
export const SR_API_ACTION_ADMIN_UPDATE_CMA_DISCUSSION =
  'SR_API_ACTION_ADMIN_UPDATE_CMA_DISCUSSION';
export const SR_API_ACTION_ADMIN_MIGRATE_REDIRECTIONS = 'SR_API_ACTION_ADMIN_MIGRATE_REDIRECTIONS';
export const SR_API_ACTION_ADMIN_ARCHIVE_RENTLINX_LEADS =
  'SR_API_ACTION_ADMIN_ARCHIVE_RENTLINX_LEADS';
export const SR_API_ACTION_ADMIN_REGENERATE_TENANT_ALERT_REPORTS =
  'SR_API_ACTION_ADMIN_REGENERATE_TENANT_ALERT_REPORTS';
export const SR_API_ACTION_ADMIN_MANAGE_CLUSTER_ENVIRONMENT =
  'SR_API_ACTION_ADMIN_MANAGE_CLUSTER_ENVIRONMENT';
export const SR_API_ACTION_ADMIN_RUN_MONTHLY_INVOICES_CRON =
  'SR_API_ACTION_ADMIN_RUN_MONTHLY_INVOICES_CRON';
export const SR_API_ACTION_ADMIN_VALIDATE_PARTNER_SIGNUP =
  'SR_API_ACTION_ADMIN_VALIDATE_PARTNER_SIGNUP';
export const SR_API_ACTION_ADMIN_MIGRATE_UTILITY_ACTIVATIONS =
  'SR_API_ACTION_ADMIN_MIGRATE_UTILITY_ACTIVATIONS';

// User Questions
export const SR_API_ACTION_UPDATE_USER_QUESTION_STATUS =
  'SR_API_ACTION_UPDATE_USER_QUESTION_STATUS';

// Households
export const SR_API_ACTION_HOUSEHOLD_GET_BY_ID = 'SR_API_ACTION_HOUSEHOLD_GET_BY_ID';
export const SR_API_ACTION_HOUSEHOLD_GET_RENTER_PROFILE =
  'SR_API_ACTION_HOUSEHOLD_GET_RENTER_PROFILE';
export const SR_API_ACTION_HOUSEHOLD_SUBMIT_RENTER_PROFILE =
  'SR_API_ACTION_HOUSEHOLD_SUBMIT_RENTER_PROFILE';
export const SR_API_ACTION_HOUSEHOLD_UPDATE_APPLICATION =
  'SR_API_ACTION_HOUSEHOLD_UPDATE_APPLICATION';
export const SR_API_ACTION_HOUSEHOLD_SUBMIT_APPLICATION =
  'SR_API_ACTION_HOUSEHOLD_SUBMIT_APPLICATION';
export const SR_API_ACTION_HOUSEHOLD_PAY_APPLICATION = 'SR_API_ACTION_HOUSEHOLD_PAY_APPLICATION';
export const SR_API_ACTION_HOUSEHOLD_PAY_APPLICATION_SUBMISSION =
  'SR_API_ACTION_HOUSEHOLD_PAY_APPLICATION_SUBMISSION';
export const SR_API_ACTION_HOUSEHOLD_PAY_SECURITY_DEPOSIT =
  'SR_API_ACTION_HOUSEHOLD_PAY_SECURITY_DEPOSIT';
export const SR_API_ACTION_HOUSEHOLD_SUBMIT_GUARANTOR_APPLICATION =
  'SR_API_ACTION_HOUSEHOLD_SUBMIT_GUARANTOR_APPLICATION';
export const SR_API_ACTION_HOUSEHOLD_GET_BY_APPLICATION_ID =
  'SR_API_ACTION_HOUSEHOLD_GET_BY_APPLICATION_ID';
export const SR_API_ACTION_HOUSEHOLD_START_APPLICATION =
  'SR_API_ACTION_HOUSEHOLD_START_APPLICATION';
export const SR_API_ACTION_HOUSEHOLD_START_GUARANTOR_APPLICATION =
  'SR_API_ACTION_HOUSEHOLD_START_GUARANTOR_APPLICATION';
export const SR_API_ACTION_HOUSEHOLD_GET_APPLICATION = 'SR_API_ACTION_HOUSEHOLD_GET_APPLICATION';
export const SR_API_ACTION_HOUSEHOLD_GET_APPLICATIONS = 'SR_API_ACTION_HOUSEHOLD_GET_APPLICATIONS';
export const SR_API_ACTION_HOUSEHOLD_GET_APPLICANT_FILE_URLS =
  'SR_API_ACTION_HOUSEHOLD_GET_APPLICANT_FILE_URLS';
export const SR_API_ACTION_HOUSEHOLD_GET_APPLICATION_SUBMISSIONS =
  'SR_API_ACTION_HOUSEHOLD_GET_APPLICATION_SUBMISSIONS';
export const SR_API_ACTION_HOUSEHOLD_REMOVE_USER = 'SR_API_ACTION_HOUSEHOLD_REMOVE_USER';
export const SR_API_ACTION_HOUSEHOLD_TAG_AS_APPLICATION_REJECTED =
  'SR_API_ACTION_HOUSEHOLD_TAG_AS_APPLICATION_REJECTED';
export const SR_API_ACTION_HOUSEHOLD_UPDATE_REJECTED_REASON =
  'SR_API_ACTION_HOUSEHOLD_UPDATE_REJECTED_REASON';
export const SR_API_ACTION_HOUSEHOLD_MARK_COMPLETED_ROOMMATE_FLOW =
  'SR_API_ACTION_HOUSEHOLD_MARK_COMPLETED_ROOMMATE_FLOW';
export const SR_API_ACTION_HOUSEHOLD_GET_RENTERS = 'SR_API_ACTION_HOUSEHOLD_GET_RENTERS';
export const SR_API_ACTION_HOUSEHOLD_GET_BY_USER_ID = 'SR_API_ACTION_HOUSEHOLD_GET_BY_USER_ID';
export const SR_API_ACTION_HOUSEHOLD_GET_BY_USER_PHONE =
  'SR_API_ACTION_HOUSEHOLD_GET_BY_USER_PHONE';
export const SR_API_ACTION_HOUSEHOLD_ASSIGN_ADMIN_USER_ID =
  'SR_API_ACTION_HOUSEHOLD_ASSIGN_ADMIN_USER_ID';
export const SR_API_ACTION_HOUSEHOLD_GENERATE_DOCS = 'SR_API_ACTION_HOUSEHOLD_GENERATE_DOCS';
export const SR_API_ACTION_HOUSEHOLD_UPDATE_LEAD_RENTER_ID =
  'SR_API_ACTION_HOUSEHOLD_UPDATE_LEAD_RENTER_ID';
export const SR_API_ACTION_HOUSEHOLD_MARK_RENTER_PREQUAL_AS_COMPLETED =
  'SR_API_ACTION_HOUSEHOLD_MARK_RENTER_PREQUAL_AS_COMPLETED';
export const SR_API_ACTION_HOUSEHOLD_GET_RENTER_LISTING_QUALIFICATION =
  'SR_API_ACTION_HOUSEHOLD_GET_RENTER_LISTING_QUALIFICATION';
export const SR_API_ACTION_HOUSEHOLD_ADD_NOTE = 'SR_API_ACTION_HOUSEHOLD_ADD_NOTE';
export const SR_API_ACTION_HOUSEHOLD_REMOVE_GUARANTOR = 'SR_API_ACTION_HOUSEHOLD_REMOVE_GUARANTOR';
export const SR_API_ACTION_HOUSEHOLD_GET_BUYERS_AGENT = 'SR_API_ACTION_HOUSEHOLD_GET_BUYERS_AGENT';
export const SR_API_ACTION_HOUSEHOLD_ARCHIVE = 'SR_API_ACTION_HOUSEHOLD_ARCHIVE';
export const SR_API_ACTION_HOUSEHOLD_MERGE_HOUSEHOLDS = 'SR_API_ACTION_HOUSEHOLD_MERGE_HOUSEHOLDS';
export const SR_API_ACTION_HOUSEHOLD_MARK_APPLICATIONS_LEASE_SIGNED =
  'SR_API_ACTION_HOUSEHOLD_MARK_APPLICATIONS_LEASE_SIGNED';
export const SR_API_ACTION_HOUSEHOLD_MARK_APPLICATIONS_PENDING_LANDLORD =
  'SR_API_ACTION_HOUSEHOLD_MARK_APPLICATIONS_PENDING_LANDLORD';
export const SR_API_ACTION_HOUSEHOLD_MARK_APPLICATIONS_ACCEPTED =
  'SR_API_ACTION_HOUSEHOLD_MARK_APPLICATIONS_ACCEPTED';
export const SR_API_ACTION_HOUSEHOLD_GET_DEPOSIT_FEES = 'SR_API_ACTION_HOUSEHOLD_GET_DEPOSIT_FEES';
export const SR_API_ACTION_HOUSEHOLD_EMAIL_DOCUMENTS = 'SR_API_ACTION_HOUSEHOLD_EMAIL_DOCUMENTS';
export const SR_API_ACTION_HOUSEHOLD_FIND_BUYERS_AGENT =
  'SR_API_ACTION_HOUSEHOLD_FIND_BUYERS_AGENT';
export const SR_API_ACTION_HOUSEHOLD_LISTING_UNARCHIVE =
  'SR_API_ACTION_HOUSEHOLD_LISTING_UNARCHIVE';
export const SR_API_ACTION_HOUSEHOLD_GET_LISTINGS_APPLYING_FOR =
  'SR_API_ACTION_HOUSEHOLD_GET_LISTINGS_APPLYING_FOR';

// Household Listings
export const SR_API_ACTION_HOUSEHOLD_LISTING_GET_BY_ID =
  'SR_API_ACTION_HOUSEHOLD_LISTING_GET_BY_ID';
export const SR_API_ACTION_HOUSEHOLD_LISTING_GET_BY_HOUSEHOLD_AND_LISTING_ID =
  'SR_API_ACTION_HOUSEHOLD_LISTING_GET_BY_HOUSEHOLD_AND_LISTING_ID';
export const SR_API_ACTION_HOUSEHOLD_LISTING_UPLOAD_LEASE_DRAFT =
  'SR_API_ACTION_HOUSEHOLD_LISTING_UPLOAD_LEASE_DRAFT';
export const SR_API_ACTION_HOUSEHOLD_LISTING_UPDATE_IN_PERSON_TOUR =
  'SR_API_ACTION_HOUSEHOLD_LISTING_UPDATE_IN_PERSON_TOUR';
export const SR_API_ACTION_HOUSEHOLD_LISTING_REJECT = 'SR_API_ACTION_HOUSEHOLD_LISTING_REJECT';
export const SR_API_ACTION_HOUSEHOLD_LISTING_CHANGE_LISTING =
  'SR_API_ACTION_HOUSEHOLD_LISTING_CHANGE_LISTING';
export const SR_API_ACTION_HOUSEHOLD_LISTING_INCREASE_SECURITY_DEPOSIT =
  'SR_API_ACTION_HOUSEHOLD_LISTING_INCREASE_SECURITY_DEPOSIT';
export const SR_API_ACTION_HOUSEHOLD_LISTING_UPDATE_COLLECT_RENT =
  'SR_API_ACTION_HOUSEHOLD_LISTING_UPDATE_COLLECT_RENT';
export const SR_API_ACTION_HOUSEHOLD_LISTING_ARCHIVE = 'SR_API_ACTION_HOUSEHOLD_LISTING_ARCHIVE';
export const SR_API_ACTION_HOUSEHOLD_LISTING_UPDATE_LEASING_INFO =
  'SR_API_ACTION_HOUSEHOLD_LISTING_UPDATE_LEASING_INFO';
export const SR_API_ACTION_HOUSEHOLD_LISTING_UPDATE_BUYERS_AGENT =
  'SR_API_ACTION_HOUSEHOLD_LISTING_UPDATE_BUYERS_AGENT';

// Household Applications
export const SR_API_ACTION_HOUSEHOLD_APPLICATION_GET_BY_USER_ID =
  'SR_API_ACTION_HOUSEHOLD_APPLICATION_GET_BY_USER_ID';
export const SR_API_ACTION_HOUSEHOLD_APPLICATION_MARK_RENTER_REQUIREMENTS =
  'SR_API_ACTION_HOUSEHOLD_APPLICATION_MARK_RENTER_REQUIREMENTS';
export const SR_API_ACTION_HOUSEHOLD_APPLICATION_SHOULD_GO_TO_CHECKOUT =
  'SR_API_ACTION_HOUSEHOLD_APPLICATION_SHOULD_GO_TO_CHECKOUT';
export const SR_API_ACTION_HOUSEHOLD_APPLICATION_PROCESS_CHARGE =
  'SR_API_ACTION_HOUSEHOLD_APPLICATION_PROCESS_CHARGE';
export const SR_API_ACTION_HOUSEHOLD_APPLICATION_MANUALLY_VERIFY_PETS =
  'SR_API_ACTION_HOUSEHOLD_APPLICATION_MANUALLY_VERIFY_PETS';
export const SR_API_ACTIONS_HOUSEHOLD_APPLICATION_UPDATE_CATEGORY =
  'SR_API_ACTIONS_HOUSEHOLD_APPLICATION_UPDATE_CATEGORY';

// Household Application Submissions
export const SR_API_ACTION_HOUSEHOLD_APPLICATION_SUBMISSION_MARK_RENTER_REQUIREMENTS =
  'SR_API_ACTION_HOUSEHOLD_APPLICATION_SUBMISSION_MARK_RENTER_REQUIREMENTS';

// Household Notes
export const SR_API_ACTION_HOUSEHOLD_NOTE_SHARE = 'SR_API_ACTION_HOUSEHOLD_NOTE_SHARE';

// Renter Profile
export const SR_API_ACTION_RENTER_PROFILE_UPDATE_CREDIT_AND_BACKGROUND_DATA =
  'SR_API_ACTION_RENTER_PROFILE_UPDATE_CREDIT_AND_BACKGROUND_DATA';

// Agents
export const SR_API_ACTION_AGENT_GET_TOURS = 'SR_API_ACTION_AGENT_GET_TOURS';
export const SR_API_ACTION_AGENT_SUBMIT_TOUR_REPORT = 'SR_API_ACTION_AGENT_SUBMIT_TOUR_REPORT';
export const SR_API_ACTION_AGENT_UPDATE_RENTER = 'SR_API_ACTION_AGENT_UPDATE_RENTER';
export const SR_API_ACTION_AGENT_GET_LISTING_SHOWING_INFO =
  'SR_API_ACTION_AGENT_GET_LISTING_SHOWING_INFO';
export const SR_API_ACTION_AGENT_GET_LEADERBOARD = 'SR_API_ACTION_AGENT_GET_LEADERBOARD';

// Landlords
export const SR_API_ACTION_LANDLORD_ASSING_TO_USER = 'SR_API_ACTION_LANDLORD_ASSING_TO_USER';
export const SR_API_ACTION_LANDLORD_GET = 'SR_API_ACTION_LANDLORD_GET';
export const SR_API_ACTION_LANDLORD_UPDATE = 'SR_API_ACTION_LANDLORD_UPDATE';

// Apartment locators
export const SR_API_ACTION_GET_ASSIGNED_APARTMENT_LOCATOR_BY_RENTER_ID =
  'SR_API_ACTION_GET_ASSIGNED_APARTMENT_LOCATOR_BY_RENTER_ID';
export const SR_API_ACTION_GET_ASSIGNED_APARTMENT_LOCATOR_BY_PHONE =
  'SR_API_ACTION_GET_ASSIGNED_APARTMENT_LOCATOR_BY_PHONE';
export const SR_API_ACTION_GET_ASSIGNED_HOUSEHOLD_ADMIN_BY_PHONE =
  'SR_API_ACTION_GET_ASSIGNED_HOUSEHOLD_ADMIN_BY_PHONE';
export const SR_API_ACTION_ASSIGN_LEAD_APARTMENT_LOCATOR =
  'SR_API_ACTION_ASSIGN_LEAD_APARTMENT_LOCATOR';
export const SR_API_ACTION_APARTMENT_LOCATOR_ADD_LEAD = 'SR_API_ACTION_APARTMENT_LOCATOR_ADD_LEAD';
export const SR_API_ACTION_CANCEL_LEAD_APARTMENT_LOCATOR_DELAYED_ASSIGNMENT =
  'SR_API_ACTION_CANCEL_LEAD_APARTMENT_LOCATOR_DELAYED_ASSIGNMENT';
export const SR_API_ACTION_ADMIN_UPDATE_ASSIGNED_APARTMENT_LOCATOR =
  'SR_API_ACTION_ADMIN_UPDATE_ASSIGNED_APARTMENT_LOCATOR';
export const SR_API_ACTION_APARTMENT_LOCATOR_GET_TWILIO_TOKEN =
  'SR_API_ACTION_APARTMENT_LOCATOR_GET_TWILIO_TOKEN';
export const SR_API_ACTION_APARTMENT_LOCATOR_GET_LEADS_LEASE_STATS =
  'SR_API_ACTION_APARTMENT_LOCATOR_GET_LEADS_LEASE_STATS';
export const SR_API_ACTION_APARTMENT_LOCATOR_TOGGLE_LEADS_ENABLED =
  'SR_API_ACTION_APARTMENT_LOCATOR_TOGGLE_LEADS_ENABLED';
export const SR_API_ACTION_APARTMENT_LOCATOR_UPDATE_LEAD_STATUS =
  'SR_API_ACTION_APARTMENT_LOCATOR_UPDATE_LEAD_STATUS';
export const SR_API_ACTION_APARTMENT_LOCATOR_UPDATE_LEAD_NOTES =
  'SR_API_ACTION_APARTMENT_LOCATOR_UPDATE_LEAD_NOTES';
export const SR_API_ACTION_APARTMENT_LOCATOR_GET_LEAD = 'SR_API_ACTION_APARTMENT_LOCATOR_GET_LEAD';
export const SR_API_ACTION_APARTMENT_LOCATOR_MARK_SEEN_ACTIVTY =
  'SR_API_ACTION_APARTMENT_LOCATOR_MARK_SEEN_ACTIVTY';
export const SR_API_ACTION_APARTMENT_LOCATOR_GET_UNSEEN_FEED_ACTIVITY_COUNT =
  'SR_API_ACTION_APARTMENT_LOCATOR_GET_UNSEEN_FEED_ACTIVITY_COUNT';
export const SR_API_ACTION_APARTMENT_LOCATOR_GET_LEADERBOARD =
  'SR_API_ACTION_APARTMENT_LOCATOR_GET_LEADERBOARD';
export const SR_API_ACTION_APARTMENT_LOCATOR_SUBMIT_APARTMENT_LEASE =
  'SR_API_ACTION_APARTMENT_LOCATOR_SUBMIT_APARTMENT_LEASE';
export const SR_API_ACTION_APARTMENT_LOCATOR_GET_APARTMENT_LEASES_BY_RENTER_USER_ID =
  'SR_API_ACTION_APARTMENT_LOCATOR_GET_APARTMENT_LEASES_BY_RENTER_USER_ID';
export const SR_API_ACTION_APARTMENT_LOCATOR_GET_COMMISSION_STRUCTURE =
  'SR_API_ACTION_APARTMENT_LOCATOR_GET_COMMISSION_STRUCTURE';
export const SR_API_ACTION_APARTMENT_LOCATOR_ASSIGN_COMMISSION_STRUCTURE =
  'SR_API_ACTION_APARTMENT_LOCATOR_ASSIGN_COMMISSION_STRUCTURE';
export const SR_API_ACTION_APARTMENT_LOCATOR_DOWNLOAD_GUEST_CARD_PDF =
  'SR_API_ACTION_APARTMENT_LOCATOR_DOWNLOAD_GUEST_CARD_PDF';
export const SR_API_ACTION_APARTMENT_LOCATOR_GET_MAX_LEADS_STATUS =
  'SR_API_ACTION_APARTMENT_LOCATOR_GET_MAX_LEADS_STATUS';
export const SR_API_ACTION_APARTMENT_TOURS_SUBMIT_TOUR_FEEDBACK =
  'SR_API_ACTION_APARTMENT_TOURS_SUBMIT_TOUR_FEEDBACK';
export const SR_API_ACTION_APARTMENT_SUBMIT_GUEST_CARD =
  'SR_API_ACTION_APARTMENT_SUBMIT_GUEST_CARD';
export const SR_API_ACTION_PARTNER_LISTINGS_CSV_IMPORT =
  'SR_API_ACTION_PARTNER_LISTINGS_CSV_IMPORT';
export const SR_API_ACTION_PARTNER_UNDO_LISTINGS_CSV_IMPORT =
  'SR_API_ACTION_PARTNER_UNDO_LISTINGS_CSV_IMPORT';
export const SR_API_ACTION_PARTNER_UPDATE_PET_SCREENING =
  'SR_API_ACTION_PARTNER_UPDATE_PET_SCREENING';

// Leases
export const SR_API_ACTION_LEASES_GET = 'SR_API_ACTION_LEASES_GET';
export const SR_API_ACTION_LEASE_DRAFT_GET_INFO = 'SR_API_ACTION_LEASE_DRAFT_GET_INFO';
export const SR_API_ACTION_LEASE_DRAFT_GET_PARTNER_CONFIGURATION =
  'SR_API_ACTION_LEASE_DRAFT_GET_PARTNER_CONFIGURATION'; // eslint-disable-line max-len
export const SR_API_ACTION_LEASE_DRAFT_GET_PARTNER_CONFIGURATION_LIST =
  'SR_API_ACTION_LEASE_DRAFT_GET_PARTNER_CONFIGURATION_LIST'; // eslint-disable-line max-len
export const SR_API_ACTION_LEASE_DRAFT_UPSERT_CONFIGURATION =
  'SR_API_ACTION_LEASE_DRAFT_UPSERT_CONFIGURATION'; // eslint-disable-line max-len

export const SR_API_ACTION_LEASE_DOCUMENT_CREATE_DRAFT =
  'SR_API_ACTION_LEASE_DOCUMENT_CREATE_DRAFT';
export const SR_API_ACTION_LEASE_DOCUMENT_REVIEW_DRAFT =
  'SR_API_ACTION_LEASE_DOCUMENT_REVIEW_DRAFT';
export const SR_API_ACTION_LEASE_DOCUMENT_REQUEST_SIGNATURE =
  'SR_API_ACTION_LEASE_DOCUMENT_REQUEST_SIGNATURE'; // eslint-disable-line max-len
export const SR_API_ACTION_LEASE_DOCUMENT_VOID = 'SR_API_ACTION_LEASE_DOCUMENT_VOID';
export const SR_API_ACTION_LEASE_DOCUMENT_GET_LIST = 'SR_API_ACTION_LEASE_DOCUMENT_GET_LIST';

// Sunlocks
export const SR_API_ACTION_SUNLOCK_ASSIGN_LISTING_ID = 'SR_API_ACTION_SUNLOCK_ASSIGN_LISTING_ID';
export const SR_API_ACTION_SUNLOCK_GET_LIST = 'SR_API_ACTION_SUNLOCK_GET_LIST';
export const SR_API_ACTION_SUNLOCK_GET_BY_ID = 'SR_API_ACTION_SUNLOCK_GET_BY_ID';
export const SR_API_ACTION_SUNLOCK_GET_BY_SERIAL_NUMBER =
  'SR_API_ACTION_SUNLOCK_GET_BY_SERIAL_NUMBER';
export const SR_API_ACTION_SUNLOCK_REGISTER = 'SR_API_ACTION_SUNLOCK_REGISTER';
export const SR_API_ACTION_SUNLOCK_SEND_COMMAND = 'SR_API_ACTION_SUNLOCK_SEND_COMMAND';
export const SR_API_ACTION_SUNLOCK_UNASSIGN_LISTING_ID =
  'SR_API_ACTION_SUNLOCK_UNASSIGN_LISTING_ID';
export const SR_API_ACTION_SUNLOCK_UPDATE_LOCK_CODES = 'SR_API_ACTION_SUNLOCK_UPDATE_LOCK_CODES';
export const SR_API_ACTION_SUNLOCK_GET_STATUS = 'SR_API_ACTION_SUNLOCK_GET_STATUS';
export const SR_API_ACTION_SUNLOCK_UPDATE_STATUS = 'SR_API_ACTION_SUNLOCK_UPDATE_STATUS';
export const SR_API_ACTION_SUNLOCK_TRIGGER_UPDATE = 'SR_API_ACTION_SUNLOCK_TRIGGER_UPDATE';
export const SR_API_ACTION_SELF_SHOWING_LOCK_REPORT_ERROR =
  'SR_API_ACTION_SELF_SHOWING_LOCK_REPORT_ERROR';
export const SR_API_ACTION_SELF_SHOWING_LOCK_REMOTE_UNLOCK =
  'SR_API_ACTION_SELF_SHOWING_LOCK_REMOTE_UNLOCK';

// Codebox
export const SR_API_ACTION_CODEBOX_GET_LIST = 'SR_API_ACTION_CODEBOX_GET_LIST';
export const SR_API_ACTION_CODEBOX_GET_BY_SERIAL_NUMBER =
  'SR_API_ACTION_CODEBOX_GET_BY_SERIAL_NUMBER';
export const SR_API_ACTION_CODEBOX_ASSIGN_LISTING_ID = 'SR_API_ACTION_CODEBOX_ASSIGN_LISTING_ID';
export const SR_API_ACTION_CODEBOX_UNASSIGN_LISTING_ID =
  'SR_API_ACTION_CODEBOX_UNASSIGN_LISTING_ID';
export const SR_API_ACTION_CODEBOX_REGISTER = 'SR_API_ACTION_CODEBOX_REGISTER';
export const SR_API_ACTION_CODEBOX_GET_CODE = 'SR_API_ACTION_CODEBOX_GET_CODE';

// ID verifications
export const SR_API_ACTION_ID_VERIFICATION_GET_BY_USER_SESSION =
  'SR_API_ACTION_ID_VERIFICATION_GET_BY_USER_SESSION';
export const SR_API_ACTION_ID_VERIFICATION_VOUCHED_VERIFICATION_FLOW_INIT =
  'SR_API_ACTION_ID_VERIFICATION_VOUCHED_VERIFICATION_FLOW_INIT';
export const SR_API_ACTION_ID_VERIFICATION_VOUCHED_VERIFICATION_FLOW_STEP =
  'SR_API_ACTION_ID_VERIFICATION_VOUCHED_VERIFICATION_FLOW_STEP';
export const SR_API_ACTION_ID_VERIFICATION_VOUCHED_VERIFICATION_FLOW_SUBMIT =
  'SR_API_ACTION_ID_VERIFICATION_VOUCHED_VERIFICATION_FLOW_SUBMIT';

// Manual ID Verifications
export const SR_API_ACTION_MANUAL_ID_VERIFICATION_CREATE =
  'SR_API_ACTION_MANUAL_ID_VERIFICATION_CREATE';
export const SR_API_ACTION_MANUAL_ID_VERIFICATION_GET_BY_ID =
  'SR_API_ACTION_MANUAL_ID_VERIFICATION_GET_BY_ID';
export const SR_API_ACTION_MANUAL_ID_VERIFICATION_REVIEW =
  'SR_API_ACTION_MANUAL_ID_VERIFICATION_REVIEW';
export const SR_API_ACTION_MANUAL_ID_VERIFICATION_GET_PENDING_LIST =
  'SR_API_ACTION_MANUAL_ID_VERIFICATION_GET_PENDING_LIST';

// Google Maps
export const SR_API_ACTION_GOOGLE_MAPS_GET_AUTOCOMPLETE_PREDICTIONS =
  'SR_API_ACTION_GOOGLE_MAPS_GET_AUTOCOMPLETE_PREDICTIONS';
export const SR_API_ACTION_GOOGLE_MAPS_GET_PLACE_DETAILS =
  'SR_API_ACTION_GOOGLE_MAPS_GET_PLACE_DETAILS';

// Partners
export const SR_API_ACTION_PARTNER_GET_BY_USER_ID = 'SR_API_ACTION_PARTNER_GET_BY_USER_ID';
export const SR_API_ACTION_PARTNER_GET_BY_SLUG = 'SR_API_ACTION_PARTNER_GET_BY_SLUG';
export const SR_API_ACTION_PARTNER_GET_BY_ID = 'SR_API_ACTION_PARTNER_GET_BY_ID';
export const SR_API_ACTION_PARTNER_GET = 'SR_API_ACTION_PARTNER_GET';
export const SR_API_ACTION_PARTNER_GET_LIST = 'SR_API_ACTION_PARTNER_GET_LIST';
export const SR_API_ACTION_PARTNER_GET_LEADS = 'SR_API_ACTION_PARTNER_GET_LEADS';
export const SR_API_ACTION_PARTNER_USER_GET_BY_USER_ID =
  'SR_API_ACTION_PARTNER_USER_GET_BY_USER_ID';
export const SR_API_ACTION_PARTNER_GET_LISTING_STATS = 'SR_API_ACTION_PARTNER_GET_LISTING_STATS';
export const SR_API_ACTION_PARTNER_GET_LISTING_PRE_LEASE_STATS =
  'SR_API_ACTION_PARTNER_GET_LISTING_PRE_LEASE_STATS';
export const SR_API_ACTION_PARTNER_GET_LISTING_STRIPE_ACCOUNT =
  'SR_API_ACTION_PARTNER_GET_LISTING_STRIPE_ACCOUNT';
export const SR_API_ACTION_PARTNER_GET_STRIPE_ACCOUNTS =
  'SR_API_ACTION_PARTNER_GET_STRIPE_ACCOUNTS';
export const SR_API_ACTION_PARTNER_GET_STRIPE_ACCOUNT = 'SR_API_ACTION_PARTNER_GET_STRIPE_ACCOUNT';
export const SR_API_ACTION_PARTNER_GET_APPLICATION_QUESTIONS_BY_ID =
  'SR_API_ACTION_PARTNER_GET_APPLICATION_QUESTIONS_BY_ID';
export const SR_API_ACTION_PARTNER_END_PRE_LEASE = 'SR_API_ACTION_PARTNER_END_PRE_LEASE';
export const SR_API_ACTION_PARTNER_CREATE_MARKETING_LISTING =
  'SR_API_ACTION_PARTNER_CREATE_MARKETING_LISTING';
export const SR_API_ACTION_PARTNER_UPDATE_MARKETING_LISTING =
  'SR_API_ACTION_PARTNER_UPDATE_MARKETING_LISTING';
export const SR_API_ACTION_PARTNER_UPDATE_MARKETING_LISTING_DUE_DATE =
  'SR_API_ACTION_PARTNER_UPDATE_MARKETING_LISTING_DUE_DATE';
export const SR_API_ACTION_PARTNER_UPDATE_MARKETING_LISTING_INSTALLED_STATUS =
  'SR_API_ACTION_PARTNER_UPDATE_MARKETING_LISTING_INSTALLED_STATUS';
export const SR_API_ACTION_PARTNER_UPDATE_SUNSETUP_LISTING =
  'SR_API_ACTION_PARTNER_UPDATE_SUNSETUP_LISTING';
export const SR_API_ACTION_PARTNER_GET_MARKETING_LISTINGS =
  'SR_API_ACTION_PARTNER_GET_MARKETING_LISTINGS';
export const SR_API_ACTION_PARTNER_GET_MARKETING_LISTING =
  'SR_API_ACTION_PARTNER_GET_MARKETING_LISTING';
export const SR_API_ACTION_PARTNER_MARK_MARKETING_LISTING_RESOLVED =
  'SR_API_ACTION_PARTNER_MARK_MARKETING_LISTING_RESOLVED';
export const SR_API_ACTION_PARTNER_EDIT_LISTING = 'SR_API_ACTION_PARTNER_EDIT_LISTING';
export const SR_API_ACTION_PARTNER_GET_LISTING_HOUSEHOLDS_INTERESTED =
  'SR_API_ACTION_PARTNER_GET_LISTING_HOUSEHOLDS_INTERESTED';
export const SR_API_ACTION_PARTNER_USER_GET_LIST = 'SR_API_ACTION_PARTNER_USER_GET_LIST';
export const SR_API_ACTION_PARTNER_GET_APARTMENT_TRAFIC_REPORT =
  'SR_API_ACTION_PARTNER_GET_APARTMENT_TRAFIC_REPORT';
export const SR_API_ACTION_PARTNER_GET_OVERVIEW_STATS = 'SR_API_ACTION_PARTNER_GET_OVERVIEW_STATS';
export const SR_API_ACTION_PARTNER_TOUR_REQUEST_CREATE =
  'SR_API_ACTION_PARTNER_TOUR_REQUEST_CREATE';
export const SR_API_ACTION_PARTNER_TOUR_REQUEST_FOLLOW_UP =
  'SR_API_ACTION_PARTNER_TOUR_REQUEST_FOLLOW_UP';
export const SR_API_ACTION_PARTNER_LISTING_HOUSEHOLDS_APPLYING =
  'SR_API_ACTION_PARTNER_LISTING_HOUSEHOLDS_APPLYING';
export const SR_API_ACTION_PARTNER_LISTING_HOUSEHOLDS_STARTED_APPLYING =
  'SR_API_ACTION_PARTNER_LISTING_HOUSEHOLDS_STARTED_APPLYING';
export const SR_API_ACTION_PARTNER_SUBMIT_LISTING_FEE_SETTINGS =
  'SR_API_ACTION_PARTNER_SUBMIT_LISTING_FEE_SETTINGS';
export const SR_API_ACTION_PARTNER_SUBMIT_PARTNER_LISTING_SETTINGS =
  'SR_API_ACTION_PARTNER_SUBMIT_PARTNER_LISTING_SETTINGS';
export const SR_API_ACTION_PARTNER_SUBMIT_PARTNER_FEE_SETTINGS =
  'SR_API_ACTION_PARTNER_SUBMIT_PARTNER_FEE_SETTINGS';
export const SR_API_ACTION_PARTNER_SEARCH_LANDLORDS = 'SR_API_ACTION_PARTNER_SEARCH_LANDLORDS';
export const SR_API_ACTION_PARTNER_GET_LISTING_TOUR_REVIEWS =
  'SR_API_ACTION_PARTNER_GET_LISTING_TOUR_REVIEWS';
export const SR_API_ACTION_PARTNER_GET_NOTES = 'SR_API_ACTION_PARTNER_GET_NOTES';
export const SR_API_ACTION_PARTNER_ADD_NOTE = 'SR_API_ACTION_PARTNER_ADD_NOTE';
export const SR_API_ACTION_PARTNER_GENERATE_REFERRAL_AGREEMENT_PDF =
  'SR_API_ACTION_PARTNER_GENERATE_REFERRAL_AGREEMENT_PDF';
export const SR_API_ACTION_PARTNER_GET_EXPERIENCE_CONFIGURATION =
  'SR_API_ACTION_PARTNER_GET_EXPERIENCE_CONFIGURATION';
export const SR_API_ACTION_PARTNER_GET_BUYERS_AGENT_COMMISSIONS =
  'SR_API_ACTION_PARTNER_GET_BUYERS_AGENT_COMMISSIONS';
export const SR_API_ACTION_PARTNER_UPDATE_BUYERS_AGENT_COMMISSIONS =
  'SR_API_ACTION_PARTNER_UPDATE_BUYERS_AGENT_COMMISSIONS';
export const SR_API_ACTION_PARTNER_UPDATE_MARKET_CONFIGURATIONS =
  'SR_API_ACTION_PARTNER_UPDATE_MARKET_CONFIGURATIONS';
export const SR_API_ACTION_PARTNER_GET_MARKET_CONFIGURATION =
  'SR_API_ACTION_PARTNER_GET_MARKET_CONFIGURATION';
export const SR_API_ACTION_PARTNER_UNINSTALL_MARKETING_ITEMS =
  'SR_API_ACTION_PARTNER_UNINSTALL_MARKETING_ITEMS';
export const SR_API_ACTION_PARTNER_GET_LISTING_LEAD_OUTCOMES =
  'SR_API_ACTION_PARTNER_GET_LISTING_LEAD_OUTCOMES';
export const SR_API_ACTION_PARTNER_SIGNED_REFERRAL_AGREEMENT_2023 =
  'SR_API_ACTION_PARTNER_SIGNED_REFERRAL_AGREEMENT_2023';
export const SR_API_ACTION_PARTNER_USER_UPSERT = 'SR_API_ACTION_PARTNER_USER_UPSERT';

export const SR_API_ACTION_PROPERTY_MANAGEMENT_SOFTWARE_GET_LIST =
  'SR_API_ACTION_PROPERTY_MANAGEMENT_SOFTWARE_GET_LIST';

export const SR_API_ACTION_GET_BREED_RESTRICTIONS = 'SR_API_ACTION_GET_BREED_RESTRICTIONS';
export const SR_API_ACTION_BITLY_CREATE_LINK = 'SR_API_ACTION_BITLY_CREATE_LINK';
export const SR_API_ACTION_GET_PET_BREED = 'SR_API_ACTION_GET_PET_BREED';

export const SR_API_ACTION_APARTMENT_UPSERT = 'SR_API_ACTION_APARTMENT_UPSERT';
export const SR_API_ACTION_APARTMENT_DELETE = 'SR_API_ACTION_APARTMENT_DELETE';
export const SR_API_ACTION_APARTMENT_GET_FLOOR_PLANS_BY_APARTMENT_ID =
  'SR_API_ACTION_APARTMENT_GET_FLOOR_PLANS_BY_APARTMENT_ID';
export const SR_API_ACTION_APARTMENT_GET_BY_BUILDING_ID =
  'SR_API_ACTION_APARTMENT_GET_BY_BUILDING_ID';
export const SR_API_ACTION_APARTMENT_GET_LIST = 'SR_API_ACTION_APARTMENT_GET_LIST';
export const SR_API_ACTION_APARTMENT_GET_REDIRECTION = 'SR_API_ACTION_APARTMENT_GET_REDIRECTION';

export const SR_API_ACTION_APARTMENT_BUILDING_GET_BY_ID =
  'SR_API_ACTION_APARTMENT_BUILDING_GET_BY_ID';
export const SR_API_ACTION_APARTMENT_BUILDING_UPSERT = 'SR_API_ACTION_APARTMENT_BUILDING_UPSERT';
export const SR_API_ACTION_APARTMENT_BUILDING_DELETE = 'SR_API_ACTION_APARTMENT_BUILDING_DELETE';

export const SR_API_ACTION_APARTMENT_SPECIAL_DEAL_UPSERT =
  'SR_API_ACTION_APARTMENT_SPECIAL_DEAL_UPSERT';
export const SR_API_ACTION_APARTMENT_SPECIAL_DEAL_GET_LIST =
  'SR_API_ACTION_APARTMENT_SPECIAL_DEAL_GET_LIST';

export const SR_API_ACTION_PROPERTY_ATTRIBUTE_UPSERT = 'SR_API_ACTION_PROPERTY_ATTRIBUTE_UPSERT';
export const SR_API_ACTION_PROPERTY_ATTRIBUTE_UPSERT_LIST =
  'SR_API_ACTION_PROPERTY_ATTRIBUTE_UPSERT_LIST';
export const SR_API_ACTION_PROPERTY_ATTRIBUTE_DELETE = 'SR_API_ACTION_PROPERTY_ATTRIBUTE_DELETE';
export const SR_API_ACTION_PROPERTY_ATTRIBUTE_DELETE_LIST =
  'SR_API_ACTION_PROPERTY_ATTRIBUTE_DELETE_LIST';
export const SR_API_ACTION_PROPERTY_ATTRIBUTE_GET_BY_LISTING_ID =
  'SR_API_ACTION_PROPERTY_ATTRIBUTE_GET_BY_LISTING_ID';
export const SR_API_ACTION_PROPERTY_ATTRIBUTE_GET_HIERARCHY =
  'SR_API_ACTION_PROPERTY_ATTRIBUTE_GET_HIERARCHY';
export const SR_API_ACTION_PROPERTY_ATTRIBUTE_GET_LIST =
  'SR_API_ACTION_PROPERTY_ATTRIBUTE_GET_LIST';

export const SR_API_ACTION_FLOOR_PLAN_UPSERT = 'SR_API_ACTION_FLOOR_PLAN_UPSERT';
export const SR_API_ACTION_FLOOR_PLAN_DELETE = 'SR_API_ACTION_FLOOR_PLAN_DELETE';
export const SR_API_ACTION_FLOOR_PLAN_GET_LIST_BY_APARTMENT_ID =
  'SR_API_ACTION_FLOOR_PLAN_GET_LIST_BY_APARTMENT_ID';
export const SR_API_ACTION_FLOOR_PLAN_GET_SHOW_UNIT = 'SR_API_ACTION_FLOOR_PLAN_GET_SHOW_UNIT';
export const SR_API_ACTION_FLOOR_PLAN_GET_BY_ID = 'SR_API_ACTION_FLOOR_PLAN_GET_BY_ID';
export const SR_API_ACTION_HELP_CARDS_GET_LIST = 'SR_API_ACTION_HELP_CARDS_GET_LIST';

// BuyersSideTourRequest
export const SR_API_ACTION_BUYERS_SIDE_TOUR_REQUEST_GET_BY_LISTING_ID =
  'SR_API_ACTION_BUYERS_SIDE_TOUR_REQUEST_GET_BY_LISTING_ID';

export const SR_API_ACTION_ACCOUNT_MANAGER_GET_LIST_WITH_PARTNERS =
  'SR_API_ACTION_ACCOUNT_MANAGER_GET_LIST_WITH_PARTNERS';
export const SR_API_ACTION_ACCOUNT_MANAGER_GET_BY_LISTING_ID =
  'SR_API_ACTION_ACCOUNT_MANAGER_GET_BY_LISTING_ID';
export const SR_API_ACTION_ACCOUNT_MANAGER_GET_LIST = 'SR_API_ACTION_ACCOUNT_MANAGER_GET_LIST';

export const SR_API_ACTION_LEASING_MANAGER_GET_LIST_WITH_PARTNERS =
  'SR_API_ACTION_LEASING_MANAGER_GET_LIST_WITH_PARTNERS';
export const SR_API_ACTION_LEASING_MANAGER_GET_BY_LISTING_ID =
  'SR_API_ACTION_LEASING_MANAGER_GET_BY_LISTING_ID';

export const SR_API_ACTION_RENTLINX_LEAD_ADD_NOTE = 'SR_API_ACTION_RENTLINX_LEAD_ADD_NOTE';
export const SR_API_ACTION_RENTLINX_LEAD_SHARE_NOTE = 'SR_API_ACTION_RENTLINX_LEAD_SHARE_NOTE';
export const SR_API_ACTION_RENTLINX_LEAD_EMAIL_DRIP_OPT_OUT =
  'SR_API_ACTION_RENTLINX_LEAD_EMAIL_DRIP_OPT_OUT';
export const SR_API_ACTION_RENTLINX_LEAD_GET_BY_PHONE = 'SR_API_ACTION_RENTLINX_LEAD_GET_BY_PHONE';
export const SR_API_ACTION_RENTLINX_LEAD_GET_BY_ID = 'SR_API_ACTION_RENTLINX_LEAD_GET_BY_ID';
export const SR_API_ACTION_RENTLINX_LEAD_VISIT_LINK = 'SR_API_ACTION_RENTLINX_LEAD_VISIT_LINK';

export const SR_API_ACTION_SUPRA_SCRAPER_PROCESS_SHOWINGS =
  'SR_API_ACTION_SUPRA_SCRAPER_PROCESS_SHOWINGS';
export const SR_API_ACTION_SUPRA_SHOWING_ADD_TOUR_FEEDBACK =
  'SR_API_ACTION_SUPRA_SHOWING_ADD_TOUR_FEEDBACK';

// Plaid
export const SR_API_ACTION_PLAID_GET_LINK_TOKEN = 'SR_API_ACTION_PLAID_GET_LINK_TOKEN';
export const SR_API_ACTION_PLAID_CREATE_STRIPE_BANK_ACCOUNT =
  'SR_API_ACTION_PLAID_CREATE_STRIPE_BANK_ACCOUNT';
export const SR_API_ACTION_PLAID_GET_STRIPE_BANK_ACCOUNT_TOKEN =
  'SR_API_ACTION_PLAID_GET_STRIPE_BANK_ACCOUNT_TOKEN';
export const SR_API_ACTION_PLAID_LINK_TOKEN_ERROR = 'SR_API_ACTION_PLAID_LINK_TOKEN_ERROR';

// Application Processing Assembly Line
export const SR_API_ACTION_ASSEMBLY_LINE_LOAD_DATA = 'SR_API_ACTION_ASSEMBLY_LINE_LOAD_DATA';
export const SR_API_ACTION_ASSEMBLY_LINE_START_APPLICATION =
  'SR_API_ACTION_ASSEMBLY_LINE_START_APPLICATION';
export const SR_API_ACTION_ASSEMBLY_LINE_UPDATE_APPLICATION =
  'SR_API_ACTION_ASSEMBLY_LINE_UPDATE_APPLICATION';
export const SR_API_ACTION_ASSEMBLY_LINE_EDIT_VOIE_DOCUMENT_TYPE =
  'SR_API_ACTION_ASSEMBLY_LINE_EDIT_VOIE_DOCUMENT_TYPE';

// Income Verification
export const SR_API_ACTION_INCOME_VERIFICATION_CREATE_SCREENING =
  'SR_API_ACTION_INCOME_VERIFICATION_CREATE_SCREENING';
export const SR_API_ACTION_INCOME_VERIFICATION_GET_BY_APPLICATION_ID =
  'SR_API_ACTION_INCOME_VERIFICATION_GET_BY_APPLICATION_ID';
export const SR_API_ACTION_INCOME_VERIFICATION_GET_BY_ID =
  'SR_API_ACTION_INCOME_VERIFICATION_GET_BY_ID';
export const SR_API_ACTION_INCOME_VERIFICATION_GET_SCREENING_URL =
  'SR_API_ACTION_INCOME_VERIFICATION_GET_SCREENING_URL';

// Employment Verification
export const SR_API_ACTION_EMPLOYMENT_VERIFICATION_CREATE =
  'SR_API_ACTION_EMPLOYMENT_VERIFICATION_CREATE';
export const SR_API_ACTION_EMPLOYMENT_VERIFICATION_GET_BY_APPLICATION_ID =
  'SR_API_ACTION_EMPLOYMENT_VERIFICATION_GET_BY_APPLICATION_ID';

// Prequal
export const SR_API_ACTION_PREQUALIFICATION_REGISTER_COMPLETION =
  'SR_API_ACTION_PREQUALIFICATION_REGISTER_COMPLETION';
export const SR_API_ACTION_PREQUALIFICATION_GET_BY_LISTING_ID =
  'SR_API_ACTION_PREQUALIFICATION_GET_BY_LISTING_ID';

// Install Orders
export const SR_API_ACTION_INSTALL_ORDERS_LOCK_TESTED = 'SR_API_ACTION_INSTALL_ORDERS_LOCK_TESTED';

// Igloohome Locks
export const SR_API_ACTION_IGLOOHOMELOCK_CREATE_LOCK = 'SR_API_ACTION_IGLOOHOMELOCK_CREATE_LOCK';
export const SR_API_ACTION_IGLOOHOMELOCK_ASSIGN_LOCK_TO_LISTING =
  'SR_API_ACTION_IGLOOHOMELOCK_ASSIGN_LOCK_TO_LISTING';
export const SR_API_ACTION_IGLOOHOMELOCK_UNASSIGN_LOCK_FROM_LISTING =
  'SR_API_ACTION_IGLOOHOMELOCK_UNASSIGN_LOCK_FROM_LISTING';
export const SR_API_ACTION_IGLOOHOMELOCK_GET_PAIRED_LOCKS =
  'SR_API_ACTION_IGLOOHOMELOCK_GET_PAIRED_LOCKS';
export const SR_API_ACTION_IGLOOHOMELOCK_GET_SELF_TOUR_CODE =
  'SR_API_ACTION_IGLOOHOMELOCK_GET_SELF_TOUR_CODE';

// Self Showing Locks
export const SR_API_ACTION_SELF_SHOWING_LOCK_UNLOCK = 'SR_API_ACTION_SELF_SHOWING_LOCK_UNLOCK';
export const SR_API_ACTION_SELF_SHOWING_LOCK_GET_CODE = 'SR_API_ACTION_SELF_SHOWING_LOCK_GET_CODE';
export const SR_API_ACTION_SELF_SHOWING_REPORT_SCAM = 'SR_API_ACTION_SELF_SHOWING_REPORT_SCAM';

// Drivers
export const SR_API_ACTION_DRIVER_GET_ALL_PER_MARKET = 'SR_API_ACTION_DRIVER_GET_ALL_PER_MARKET';
export const SR_API_ACTION_DRIVER_UPDATE_LISTING = 'SR_API_ACTION_DRIVER_UPDATE_LISTING';
export const SR_API_ACTION_DRIVERS_GET_BY_USER_ID = 'SR_API_ACTION_DRIVERS_GET_BY_USER_ID';
export const SR_API_ACTION_DRIVERS_GET_LIST = 'SR_API_ACTION_DRIVERS_GET_LIST';
export const SR_API_ACTION_DRIVERS_UPDATE_STATUS = 'SR_API_ACTION_DRIVERS_UPDATE_STATUS';

// Job Orders
export const SR_API_ACTION_JOB_ORDER_CREATE = 'SR_API_ACTION_JOB_ORDER_CREATE';
export const SR_API_ACTION_JOB_ORDER_EDIT = 'SR_API_ACTION_JOB_ORDER_EDIT';
export const SR_API_ACTION_JOB_ORDER_GET_BY_ID = 'SR_API_ACTION_JOB_ORDER_GET_BY_ID';
export const SR_API_ACTION_JOB_ORDER_UPDATE_STATUS = 'SR_API_ACTION_JOB_ORDER_UPDATE_STATUS';
export const SR_API_ACTION_JOB_ORDER_ASSIGN_DRIVER = 'SR_API_ACTION_JOB_ORDER_ASSIGN_DRIVER';
export const SR_API_ACTION_JOB_ORDER_UNASSIGN_DRIVER = 'SR_API_ACTION_JOB_ORDER_UNASSIGN_DRIVER';
export const SR_API_ACTION_JOB_ORDER_ACCEPT = 'SR_API_ACTION_JOB_ORDER_ACCEPT';
export const SR_API_ACTION_JOB_ORDER_NOTE_CREATE = 'SR_API_ACTION_JOB_ORDER_NOTE_CREATE';

// Jobs
export const SR_API_ACTION_JOB_UPDATE = 'SR_API_ACTION_JOB_UPDATE';
// TODO: Remove, it is not being used apparently..
export const SR_API_ACTION_JOB_UPDATE_STATUS = 'SR_API_ACTION_JOB_UPDATE_STATUS';

// Inventory
export const SR_API_ACTION_INVENTORY_GET_BY_BARCODE = 'SR_API_ACTION_INVENTORY_GET_BY_BARCODE';
export const SR_API_ACTION_INVENTORY_ITEM_REGISTER = 'SR_API_ACTION_INVENTORY_ITEM_REGISTER';
export const SR_API_ACTION_INVENTORY_ITEM_SCAN = 'SR_API_ACTION_INVENTORY_ITEM_SCAN';
export const SR_API_ACTION_INVENTORY_ITEM_GET_BY_SERIAL_NUMBER =
  'SR_API_ACTION_INVENTORY_ITEM_GET_BY_SERIAL_NUMBER';
export const SR_API_ACTION_INVENTORY_ITEM_UPDATE = 'SR_API_ACTION_INVENTORY_ITEM_UPDATE';
export const SR_API_ACTION_INVENTORY_SCAN_GEOLOCATION_ERROR =
  'SR_API_ACTION_INVENTORY_SCAN_GEOLOCATION_ERROR';
export const SR_API_ACTION_INVENTORY_ITEM_GROUP_SCAN = 'SR_API_ACTION_INVENTORY_ITEM_GROUP_SCAN';

// Inventory Owner
export const SR_API_ACTION_INVENTORY_OWNER_CREATE = 'SR_API_ACTION_INVENTORY_OWNER_CREATE';

export const SR_API_ACTION_DRIVERS_CREATE_ACCOUNT = 'SR_API_ACTION_DRIVERS_CREATE_ACCOUNT';

// Invoice
export const SR_API_ACTION_INVOICE_REGENERATE = 'SR_API_ACTION_INVOICE_REGENERATE';
export const SR_API_ACTION_INVOICE_CANCEL = 'SR_API_ACTION_INVOICE_CANCEL';

// Concessions
export const SR_API_ACTION_CONCESSIONS_GET_BY_LISTING_ID =
  'SR_API_ACTION_CONCESSIONS_GET_BY_LISTING_ID';
export const SR_API_ACTION_CONCESSIONS_END = 'SR_API_ACTION_CONCESSIONS_END';
export const SR_API_ACTION_CONCESSIONS_CREATE = 'SR_API_ACTION_CONCESSIONS_CREATE';

// Routable
export const SR_API_ACTION_ROUTABLE_LIST_ACCOUNTS = 'SR_API_ACTION_ROUTABLE_LIST_ACCOUNTS';
export const SR_API_ACTION_ROUTABLE_LIST_TEAM_MEMBERS = 'SR_API_ACTION_ROUTABLE_LIST_TEAM_MEMBERS';
export const SR_API_ACTION_ROUTABLE_CREATE_INVOICE = 'SR_API_ACTION_ROUTABLE_CREATE_INVOICE';

// Billing Fees
export const SR_API_ACTION_BILLING_FEES_UPSERT = 'SR_API_ACTION_BILLING_FEES_UPSERT';

// Renewals
export const SR_API_ACTION_RENEWALS_CREATE = 'SR_API_ACTION_RENEWALS_CREATE';

// Discounts
export const SR_API_ACTION_DISCOUNTS_CREATE = 'SR_API_ACTION_DISCOUNTS_CREATE';

// Hitlist Tasks
export const SR_API_ACTION_HITLIST_TASK_START = 'SR_API_ACTION_HITLIST_TASK_START';
export const SR_API_ACTION_HITLIST_TASK_COMPLETE = 'SR_API_ACTION_HITLIST_TASK_COMPLETE';
export const SR_API_ACTION_HITLIST_TASK_UPDATE = 'SR_API_ACTION_HITLIST_TASK_UPDATE';
export const SR_API_ACTION_HITLIST_TASK_GET_LIST = 'SR_API_ACTION_HITLIST_TASK_GET_LIST';
export const SR_API_ACTION_HITLIST_TASK_GET_CALL_SCRIPTS =
  'SR_API_ACTION_HITLIST_TASK_GET_CALL_SCRIPTS';
export const SR_API_ACTION_HITLIST_TASK_SEND_VOICEMAIL_FOLLOW_UP_TEXT =
  'SR_API_ACTION_HITLIST_TASK_SEND_VOICEMAIL_FOLLOW_UP_TEXT';

// Bug reports
export const SR_API_ACTION_REPORT_BUG = 'SR_API_ACTION_REPORT_BUG';

// Partner Tasks
export const SR_API_ACTION_ADMIN_CREATE_PARTNER_TASKS_FROM_TOUR_REVIEWS =
  'SR_API_ACTION_ADMIN_CREATE_PARTNER_TASKS_FROM_TOUR_REVIEWS';
export const SR_API_ACTION_PARTNER_TASK_GET_LIST = 'SR_API_ACTION_PARTNER_TASK_GET_LIST';
export const SR_API_ACTION_PARTNER_TASK_UPDATE_STATUS = 'SR_API_ACTION_PARTNER_TASK_UPDATE_STATUS';
export const SR_API_ACTION_PARTNER_TASK_REDUCE_PRICE = 'SR_API_ACTION_PARTNER_TASK_REDUCE_PRICE';
export const SR_API_ACTION_PARTNER_TASK_ARCHIVE = 'SR_API_ACTION_PARTNER_TASK_ARCHIVE';

// Metabase
export const SR_API_ACTION_METABASE_CHART_GET_BY_PARTNER_ID =
  'SR_API_ACTION_METABASE_CHART_GET_BY_PARTNER_ID';
export const SR_API_ACTION_METABASE_CHART_LOAD_IFRAME_URLS =
  'SR_API_ACTION_METABASE_CHART_LOAD_IFRAME_URLS';

// OpenAI
export const SR_API_ACTION_OPENAI_REQUEST = 'SR_API_ACTION_OPENAI_REQUEST';

/* eslint-enable max-len */
